import { AuthPage, AuthTitle } from "../components/authForms";

import ChangePasswordForm from "../components/ChangePasswordForm";
import applyHocs from "../lithic/applyHocs";
import { constrained } from "../components/layouts";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

function ChangePasswordPage() {
  const history = useHistory();

  function onSuccess() {
    toast.success("Your password has been changed.");
    history.push("/dashboard");
  }

  return (
    <AuthPage>
      <AuthTitle>Change password</AuthTitle>
      <ChangePasswordForm onSuccess={onSuccess} />
    </AuthPage>
  );
}

export default applyHocs(constrained("sm"), ChangePasswordPage);
